var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bulk-project-main-image"},[(!_vm.isLoading)?_c('img',{attrs:{"src":_vm.thumbnailImage},on:{"click":_vm.launchGalleria}}):_c('moon-loader',{staticClass:"_loading-spinner",attrs:{"color":'#cbe9fb',"size":'128px'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }